<template>
  <div :class="'option-card'">
    <!-- {{option}} -->
    <div class="option-info">
      <div class="option-text">
        <div class="option-name">{{option.name || option.view.name}}</div>
        <div class="option-desctiption">
          {{option.description || (option.view ? option.view.description : '')}}
        </div>
      </div>
      <div class="option-image" v-if="option.imageUrl && !hideImage">
        <img :src="option.imageUrl" @error="setAltImg">
      </div>
    </div>
      
    <div class="actions">
      <div v-if="!hasValues" v-bind:class="active ?'':'disabled'" class="btn btn--primary button-add" @click="onAdd">
        {{ $t(addLabel || "add") }}
      </div>
      <template v-else>
        <div class="btn btn--primary button-edit" @click="onEdit">
          {{ $t(editLabel || "edit") }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionCard',
  props: ['optionType', 'option', 'hasValues', 'hideImage', 'addLabel', 'editLabel', 'active'],
  methods: {
    onAdd () {
      this.$emit('addOption', {optionType: this.optionType, option: this.option})
    },
    onEdit (){
      this.$emit('configureOption', {optionType: this.optionType, option: this.option})
    },
    onRemove () {
      this.$emit('removeOption', {optionType: this.optionType, option: this.option})
    },
    setAltImg(event) { 
        event.target.src = ""
    }
  }
}
</script>

<style lang="stylus" scoped>
.option-card
  color $trout
  padding-bottom 15px
  &:not(:last-child)
    margin-bottom: 15px
    border-bottom 1px solid $mystic

  .option-info
    display flex

  .option-image
    margin-left auto
    width 120px
    flex 0 0 120px
    padding-left 10px
    img
      width 100%

  .option-name
    m-font-size(16, 18)
    font-weight: $fw-semi-bold
    margin-bottom: 7px

  .option-desctiption
    m-font-size(14, 18)
    font-weight: $fw-light
    margin-bottom: 15px

  .actions
    display: flex
</style>